<template>
  <div v-if="lotPurchasedModal.lot.currency" class="ta-bid-created-modal-data ta-bid-created-modal-bid-increment">
    <div class="ta-data-label">
      {{ label }}
    </div>
    <div class="ta-data-value">
      {{nextIncrement | asCurrency(lotPurchasedModal.lot.currency.code)}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getIncrements} from "@/helpers";

export default {
  name: "BidIncrement",
  props: {
    label: {
      type: String,
      default() {
        return this.$t('Bid Increment')
      }
    }
  },
  computed: {
    ...mapState(['lotPurchasedModal']),
    nextIncrement() {
      const increments = getIncrements(this.lotPurchasedModal.lot);
      return increments[0]?.increment
    }
  }
}
</script>

<style scoped>

</style>
